<template>
  <div class="page-wrapper storybook-cnc-badge-number">
    <StorybookTemplate title="CncBadgeNumber" pathComponent="/shared/elements/global/v1/CncBadgeNumber.vue" :propList="propList" :form.sync="form">
      <CncBadgeNumber v-bind="form">{{ form.name }}</CncBadgeNumber>
    </StorybookTemplate>
  </div>
</template>

<script>
export default {
  components: {
    StorybookTemplate: () => import('../../../../components/StorybookTemplate.vue')
  },
  data () {
    return {
      propList: [
        { name: 'currency', type: 'input', param: 'currency' },
        { name: 'number', type: 'slider', param: 'number', min: 0, max: 12000000 },
        { name: 'isAbbreviated', type: 'boolean', param: 'isAbbreviated' },
        { name: 'outline', type: 'boolean', param: 'outline' },
        {
          name: 'size',
          type: 'select',
          param: 'size',
          default: 'medium',
          option: [
            { label: 'extra-small', name: 'Extra Small' },
            { label: 'small', name: 'Small' },
            { label: 'medium', name: 'Medium' },
            { label: 'large', name: 'Large' }
          ]
        }
      ],

      form: {
        number: 2,
        isAbbreviated: false,
        size: 'medium'
      }
    }
  }
}
</script>
